import './style.css';

import React, { Children, ReactNode, useEffect, useState } from 'react';
import clsx from 'clsx';

type TitleType = ReactNode;
type TabProps = {
  children?: ReactNode; // ممکنه یک یا چند پنل باشه
  titles: TitleType[];
  active?: number; // 1-based
};

export default function GTab({ children, titles, active = 1 }: TabProps) {
  const panes = Children.toArray(children);
  const clamp = (n: number) => Math.min(Math.max(n, 0), titles.length - 1);
  const [idx, setIdx] = useState(clamp(active - 1));

  // اگر prop active تغییر کرد، sync شو
  useEffect(() => {
    setIdx(clamp(active - 1));
  }, [active, titles.length]);

  return (
    <>
      <ul className="gTab nav nav-tabs lined" role="tablist">
        {titles.map((item, i) => {
          const isActive = i === idx;
          const tabId = `tab-${i}`;
          const btnId = `tab-btn-${i}`;
          return (
            <li className="nav-item" key={i} role="presentation">
              {/* از button استفاده کن تا ناوبری hash نداشته باشی */}
              <button
                id={btnId}
                role="tab"
                aria-controls={tabId}
                aria-selected={isActive}
                type="button"
                className={clsx('nav-link', isActive && 'active')}
                onClick={() => setIdx(i)}
              >
                {item}
              </button>
            </li>
          );
        })}
      </ul>

      <div className="tab-content">
        {panes.map((pane, i) => {
          const isActive = i === idx;
          const tabId = `tab-${i}`;
          const btnId = `tab-btn-${i}`;
          return (
            <div
              key={tabId}
              id={tabId}
              role="tabpanel"
              aria-labelledby={btnId}
              className={clsx('tab-pane fade', isActive && 'show active')}
            >
              {pane}
            </div>
          );
        })}
      </div>
    </>
  );
}

export function ScrollTab(props: TabProps) {
  const { children, titles, active = 1 } = props;

  const [, setActive] = useState(1);

  useEffect(() => {
    if (active) {
      setActive(active);
    }
  }, [active]);

  const changeActive = (index: number) => {
    setActive(index);
  };

  return (
    <React.Fragment>
      <ul className="d-flex position-relative gTabScroll">
        {titles?.map((item: TitleType, index: number) => (
          <li
            key={index}
            onClick={() => changeActive(index + 1)}
            className={clsx(
              active === index + 1 && 'active',
              'px-4',
              'py-2',
              'position-relative'
            )}
          >
            <div
              className={clsx(
                'd-flex position-relative justify-content-center'
              )}
            >
              <div className="subtitle2">{item}</div>
            </div>
            <div className={clsx(active === index + 1 && 'activeLine')} />
          </li>
        ))}
      </ul>

      <div className="tab-content">
        {children?.map((item: never, index: number) => (
          <div
            role="tabpanel"
            id={`tab-${index}`}
            className={clsx(
              'tab-pane fade',
              active === index + 1 && 'show active'
            )}
          >
            {item}
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}
